module.exports = __webpack_public_path__ + "img/Nuestra Cultura.3e5207b4.png";